import dayjs from 'dayjs';

const convertFilter = formData => {
  const { endDate, itemsOnPage, page, beginDate, type, username, statuses } = formData;

  const count = itemsOnPage.find(i => i.active)?.value ?? 10;
  const activeStatuses = statuses.filter(s => s.active).map(s => s.value);

  const params = new URLSearchParams();

  params.append('statuses', activeStatuses.join(','));

  if (username.length > 0) params.set('username', username);
  params.set('page', page + 1);
  params.set('count', count);
  params.set('date_from', dayjs(beginDate).format('YYYY-MM-DD'));
  params.set('date_to', dayjs(endDate).add(1, 'day').format('YYYY-MM-DD'));
  if (type.value !== 'all') params.set('type', type.value);

  return params;
};

export default convertFilter;
